// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"ae952c24","408":"633be348","482":"ae952c24"}[chunkId] + ".chunk.css";
};